import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { Row, Col, Button } from 'react-bootstrap';

import Uuid from '../../../../../support/Uuid';
import CartaPorteMercancias from './CartaPorteMercancias';
import CartaPorteMercanciasList from './CartaPorteMercanciasList';
import CartaPorteMercanciaResumenForm from './CartaPorteMercanciaResumenForm';
import CartaPorteMercanciasCalculator from '../../../support/cartaporte/CartaPorteMercanciasCalculator';

class CartaPorteMercanciasManager extends Component {
  state = {};

  handleOnAdd = (data) => {
    const { Mercancias = {} } = this.props.data;
    const { Mercancia = [] } = Mercancias;

    const newData = Mercancia.concat([
      {
        id: Uuid.v4(),
        ...data,
      },
    ]);

    this.handleOnListChange(newData);
  };

  handleOnUploadFile = (data) => {
    const { Mercancias = {} } = this.props.data;
    const { Mercancia = [] } = Mercancias;

    let newData = _.map(data, (item) => {
      item.id = Uuid.v4();

      return item;
    });

    newData = Mercancia.concat(newData);

    this.handleOnListChange(newData);
  };

  handleOnListChange = (data) => {
    const mercancias = this.props.data.Mercancias || {};
    const totalizer = CartaPorteMercanciasCalculator.make(data).get();
    const event = { isValid: true, name: 'mercancias' };

    this.props.onChange(
      {
        ...this.props.data,
        Mercancias: {
          ...mercancias,
          PesoBrutoTotal: totalizer.PesoBrutoTotal,
          NumTotalMercancias: totalizer.NumTotalMercancias,
          Mercancia: data,
        },
      },
      event
    );
  };

  handleOnChange = (data) => {
    const mercancias = this.props.data.Mercancias || {};

    const event = { isValid: true, name: 'mercancias' };

    this.props.onChange(
      {
        ...this.props.data,
        Mercancias: {
          ...mercancias,
          ...data,
        },
      },
      event
    );
  };

  handleOnEdit = (item) => {
    item = { ...item };

    const date = !!item.FechaCaducidad ? moment(item.FechaCaducidad) : undefined;

    if (date) {
      item.FechaCaducidad = date.toDate();
    }

    this.setState(
      {
        data: item,
        key: 'form',
      },
      () => {
        this.setState({
          data: undefined,
          key: 'form',
        });
      }
    );
  };

  handleOnDelete = () => {
    this.props.onChange({
      ...this.props.data,
      Mercancias: {},
    });
  };

  render() {
    const { data } = this.state;
    const { Mercancias = {}, Version } = this.props.data;
    const { Mercancia = [] } = Mercancias;

    return (
      <div className="pb-4">
        <div>
          <strong className="text-black text-upper">Mercancias</strong>
        </div>

        <div className="section">
          <div className="pt-2">
            <CartaPorteMercancias
              data={data}
              version={Version}
              onAdd={this.handleOnAdd}
              onUploadFile={this.handleOnUploadFile}
            />
          </div>

          <div className="pt-2">
            <CartaPorteMercanciasList
              data={Mercancia}
              onEdit={this.handleOnEdit}
              onChange={this.handleOnListChange}
            />
          </div>

          <Row>
            <Col>
              <Button
                variant="danger"
                disabled={Mercancia.length === 0}
                onClick={this.handleOnDelete}
              >
                Eliminar mercancías
              </Button>
            </Col>
          </Row>

          <div className="mt-3 pt-2">
            <CartaPorteMercanciaResumenForm
              data={Mercancias}
              version={Version}
              onChange={this.handleOnChange}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default CartaPorteMercanciasManager;
